import React from 'react';
import { motion } from 'framer-motion';
export function SolutionBenefits() {
  const benefits = [{
    emoji: '✨',
    text: <>
          Each pattern respects the{' '}
          <span className="text-teal font-bold" data-id="element-367">real anatomy of the breed</span>
          : the ears, the snout, the unique expression. They are not generic.
        </>
  }, {
    emoji: '🎨',
    text: <>
          Included guide to adapt each pattern to the{' '}
          <span className="text-teal font-bold" data-id="element-368">exact color of YOUR pet</span>.
          Spots, tones, marks... make it identical.
        </>
  }, {
    emoji: '🥹',
    text: <>
          When they see it, they will say:{' '}
          <span className="text-teal font-bold" data-id="element-369">
            "It looks exactly like them!"
          </span>
          . Get ready for tears of joy.
        </>
  }, {
    emoji: '🎬',
    text: <>
          <span className="text-teal font-bold" data-id="element-370">
            You do not need previous experience
          </span>
          . We include 10 video classes of basic crochet stitches so you can
          start from scratch with confidence.
        </>
  }];
  return <section className="py-10 md:py-16 bg-white" data-id="element-371">
      <div className="max-w-3xl mx-auto px-4" data-id="element-372">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-8" data-id="element-373">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-deep-brown" data-id="element-374">
            Imagine being able to crochet{' '}
            <span className="text-terracotta italic border-b-2 border-terracotta/60 pb-0.5" data-id="element-375">
              exactly
            </span>{' '}
            your pet
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-376">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -15
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.08,
          duration: 0.4
        }} className="etsy-card p-5 flex items-start gap-4" data-id="element-377">
              <span className="text-2xl flex-shrink-0 mt-0.5" data-id="element-378">
                {benefit.emoji}
              </span>
              <p className="text-gray-600 leading-relaxed" data-id="element-379">{benefit.text}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}